"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var PageSizeSelector = function PageSizeSelector(pageSizes, onPageSizeChange) {
  return pageSizes.map(function (size) {
    return {
      value: size,
      title: "".concat(size, " rows"),
      onClick: function onClick(e) {
        return onPageSizeChange(parseInt(e.target.getAttribute('value')));
      },
      variant: 'primary'
    };
  });
};

var _default = PageSizeSelector;
exports.default = _default;